// api.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // 你的后端API基地址
  timeout: 10000, // 超时时间（毫秒）
  headers: {
    'Content-Type': 'application/json',// 默认请求头
  },
  withCredentials: true
});

// api.interceptors.response.use((response) => {
//   // 对响应数据做些公共处理
//   return response;
// }, (error) => {
//   if (error.response) {
//     switch (error.response.status) {
//       case 401:
//         console.error('未授权，请重新登录');
//         break;
//       case 404:
//         console.error('请求的资源不存在');
//         break;
//       case 500:
//         console.error('服务器内部错误');
//         break;
//       default:
//         console.error('请求失败:', error.message);
//     }
//   }
//   return Promise.reject(error);
// });
export default api;